<template>
  <q-modal
      :value="opened"
      @close="close()"
      @escape-key="close()"
      @hide="close()"
  >
    <div class="q-pa-lg">
      <q-inner-loading :visible="actsLoading">
        <q-spinner size="50px" color="primary"></q-spinner>
      </q-inner-loading>

      <acts-list-table
          v-if="!actsLoading"
          :acts="acts"
      />

      <div class="row justify-end q-mt-md">
        <q-btn
            @click="close()"
            color="primary"
            flat
            class="q-ml-sm"
            label="Отмена"
        />
      </div>
    </div>
  </q-modal>
</template>

<script>
import {
  QBtn,
  QField,
  QDatetime,
  QInput,
  QModal,
  QInnerLoading,
  QSpinner
} from 'quasar';

import ActsListTable from "./ActsListTable";

import {mapState} from "vuex";

export default {
  name: 'ActsListModal',

  components: {
    ActsListTable,
    QInput,
    QBtn,
    QField,
    QDatetime,
    QModal,
    QInnerLoading,
    QSpinner
  },

  props: {
    opened: true,

    billNumber: {
      type: String,
      required: true
    },

    documentId: {
      type: String,
      required: true
    }
  },

  computed: {
    ...mapState({
      acts: state => state.project.actsChain
          .map((act) => ({ ...act, deleting: false })),
      actsLoading: state => state.project.actsChainLoading,
    }),
  },

  created() {
    this.fetchDocumentsList();
  },

  methods: {
    fetchDocumentsList() {
      this.$store.dispatch('project/fetchActsChain', {
        projectId: this.$route.params.id,
        documentId: this.documentId,
        billNumber: this.billNumber
      })
    },

    close() {
      this.$emit('modal-closed')
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/ActsList/ActsListModal.vue